import Lottie from 'lottie-react';

import faceIdJson from '../jsons/face-id-hover-scanning.json';

const FaceIdScan = props => {
  return <Lottie loop={false} animationData={faceIdJson} {...props} />;
};

export default FaceIdScan;
